import { Trans } from 'react-i18next';
import BackArrow from '../../assets/backArrowIcon.svg';
import ButtonSpinner from '../../assets/buttonLoading/buttonLoading';
import { TabletViewProps } from './type';

const TabletView = ({
  children,
  currentStep,
  onBack,
  onSkip,
  isLoading,
  showBackButton = true,
  showSkipButton = true,
  showStepIndicator = true,
}: TabletViewProps) => {
  return (
    <div className="min-h-screen w-full font-helvetica bg-white">
      <div className="min-h-screen w-full flex flex-col justify-center">
        {(showBackButton || showStepIndicator || showSkipButton) && (
          <div className="flex justify-between items-center mt-16 mb-8 px-[4.25rem]">
            {showBackButton && onBack && (
              <div
                className="w-12 h-12 flex items-center justify-center cursor-pointer bg-white rounded-full shadow-[0_2px_12px_0px_rgba(0,0,0,0.08)]"
                onClick={onBack}
              >
                {isLoading ? (
                  <ButtonSpinner loadingColor="black" />
                ) : (
                  <img src={BackArrow} alt="Back Arrow" className="w-5 h-5" />
                )}
              </div>
            )}
            {showStepIndicator && (
              <div className="text-center flex-1">
                <p className="text-[16px] text-gray-600 mb-2">
                  {currentStep}/4
                </p>
                <h1 className="text-[32px] leading-[40px] font-medium text-[#1A1A1A]">
                  <Trans i18nKey={`onboarding.step${currentStep}Title`} />
                  {currentStep === 1 && process.env.REACT_APP_WEB_TITLE}
                </h1>
              </div>
            )}
            {showSkipButton && onSkip && (
              <div
                className="w-12 h-12 flex items-center justify-center cursor-pointer"
                onClick={onSkip}
              >
                <span className="text-[16px]">
                  <Trans i18nKey="onboarding.skip" />
                </span>
              </div>
            )}
          </div>
        )}
        <div className="flex-1 flex flex-col justify-center mx-auto w-full px-[4.25rem]">
          <div className="flex flex-col h-full">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default TabletView;
